<div *ngIf="commission">
    <div *ngIf="showRange">Commission between
        <app-currency-amount [currencyAmountType]="calculateCommission(lowestFee)"></app-currency-amount>
        -
        <app-currency-amount [currencyAmountType]="calculateCommission(highestFee)"></app-currency-amount> / day
    </div>

    <div *ngIf="lowestFee && !showRange">
        Commission from <app-currency-amount [currencyAmountType]="calculateCommission(lowestFee)"></app-currency-amount> / day
    </div>

    <div *ngIf="!showRange && highestFee">
        Commission up to <app-currency-amount [currencyAmountType]="calculateCommission(highestFee)"></app-currency-amount> / day
    </div>

    <div *ngIf="exactFee" class="commission-rate _flex _justify-center _gap-1 xs:_gap-2 _py-1" [ngClass]="modifierClasses ? modifierClasses : ''">
        <span *ngIf="caption">{{caption}}</span>
        <span class="_font-bold" *ngIf="showAmount">
          <app-currency-amount [currencyAmountType]="calculateCommission(exactFee)"></app-currency-amount>
        </span>

        <span *ngIf="showAmount && showPercentage">/</span>

        <span *ngIf="showPercentage">{{commission.rate}}%</span>
    </div>
</div>
